var _defs, _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew200({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.86,3.86a5.87,5.87,0,0,0,0,8.28L8,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.86,12.14a5.87,5.87,0,0,0,8.28,0L8,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.86,3.86,8,8l4.14-4.14A5.87,5.87,0,0,0,3.86,3.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.14,12.14a5.87,5.87,0,0,0,0-8.28L8,8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew200);
export default __webpack_public_path__ + "static/media/Symbolpack_New_200.176f8daffa88cdcf7caf385c534698f1.svg";
export { ForwardRef as ReactComponent };